import React, { useMemo } from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import { FieldInput } from '../../../../../components/redux-form/fields/FieldInput';
import classNames from 'classnames';
import styles from '../assets/validate-code-form.module.scss';
import { useTranslation } from 'react-i18next';
import { required, Validators } from '../../../../../components/redux-form/utils/validators';
import { asyncAuthValidateRecoveryCode } from '../../../../../store/actions/auth-actions';
import { Link } from 'react-router-dom';
import Router from '../../../../../navigation/router';
import { routes } from '../../../../../navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';

export interface ValidateCodeFormData {
    token: string;
}

interface ValidateCodeFormProps {}

type InjectedProps = InjectedFormProps<ValidateCodeFormData, ValidateCodeFormProps>;

const ValidateCodeForm: React.FunctionComponent<InjectedProps & ValidateCodeFormProps> = ({
    handleSubmit,
    submitting,
    error,
}: InjectedProps & ValidateCodeFormProps) => {
    const { t } = useTranslation();
    const validators: Validators<ValidateCodeFormData> = useMemo(
        () => ({
            token: [required()],
        }),
        [],
    );

    return (
        <div className={classNames('')}>
            <div className={classNames('col-lg-3')}></div>
            <div className={classNames(styles.authContent)}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: '30px',
                        marginBottom: '10px',
                    }}
                >
                    <div className={classNames(styles.infoIcon, '  d-flex justify-content-center align-items-center')}>
                        <FontAwesomeIcon className={classNames(styles.icon)} icon={faQuestion} />
                    </div>
                    <div className={classNames(styles.infoIconTitle)}>Forgot the password</div>
                </div>
                <form onSubmit={handleSubmit} className={classNames(styles.form)}>
                    <div>
                        <FormError error={error} />
                        <FieldInput
                            name="token"
                            type="text"
                            validate={validators.token}
                            wrapperConfig={{
                                label: t('Enter the verification code from your mailbox:'),
                            }}
                        />
                    </div>
                    <div className={classNames('text-center')}>
                        <button type="submit" className={classNames('btn', 'btn-success', 'text-uppercase', 'w-100')}>
                            {submitting ? <span className={classNames('spinner-border')} /> : t('Confirm')}
                        </button>
                    </div>
                    <div className={classNames(styles.links, 'text-center', 'mb-2')}>
                        <Link to={Router.generate(routes.HOME)}>back to login</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default reduxForm<ValidateCodeFormData, ValidateCodeFormProps>({
    form: 'password-validate-code',
    onSubmit: asyncAuthValidateRecoveryCode,
})(ValidateCodeForm);
